<ape-drawer
  [visible]="visible"
  [title]="TRANSLATION_KEYS.notifications.TITLE"
  [position]="'right'"
  [closable]="true"
  [dismissible]="true"
  [styleClass]="'min-w-full w-full md:min-w-[450px] md:max-w-[450px] [&>.p-drawer-header]:!p-0 [&>.p-drawer-content]:!p-[20px_24px] [&>.p-drawer-header]:sm:!p-0 [&>.p-drawer-content]:sm:!p-[20px_24px]'"
  (visibleChange)="onVisibleChange($event)"
  (closeClick)="close()"
  [headerBadgeSeverity]="'danger'"
  [headerbadgeCounter]="(unreadCount$ | async) ?? 0"
>

  <div class="flex flex-col h-full gap-4">
    <!-- Subtitle con conteggio -->
    <hr class="border-gray-200">
    <div class="flex items-center justify-between">
      <p class="text-gray-500 text-lg">
        {{ TRANSLATION_KEYS.notifications.SUBTITLE | translate }}
      </p>
    </div>
    <hr class="border-gray-200">

    <div class="flex items-center justify-between gap-2">
      <ape-button
        [variant]="'simple-notification'"
        [leftIcon]="'assets/icons/check.svg'"
        [label]="TRANSLATION_KEYS.notifications.MARK_ALL_READ | translate"
        [fullWidth]="true"
        [cssClassText]="'text-[var(--colors-gray-scale-black)]!'"
        (buttonClick)="onMarkAllAsRead()"
      />
      <ape-simple-select
        [selectedOption]="selectedFilter"
        [options]="options"
        (selectionChange)="onSelectionChange($event)"
        [placeholder]="TRANSLATION_KEYS.notifications.ALL_NOTIFICATIONS | translate"
      />
    </div>
    <!-- Lista notifiche -->
    <div class="flex-1 overflow-y-auto -mx-6">
      @if (loading$ | async) {
      <div class="flex justify-center items-center py-8">
        <span class="text-gray-400">Loading...</span>
      </div>
      } @else {
      @for (notification of notifications$ | async; track notification.notificationId) {
      <ape-notification-item
        [notification]="notification"
        (notificationClick)="onNotificationClick($event)"
      />
      } @empty {
      <p class="text-center text-gray-400 py-8 px-4">
        {{ TRANSLATION_KEYS.notifications.NO_NOTIFICATIONS | translate }}
      </p>
      }
      }
    </div>
  </div>
</ape-drawer>